import invoiceDate from './invoice-date';
import invoiceDownload from './invoice-download';
import invoiceNumber from './invoice-number';
import invoiceSubtotal from './invoice-subtotal';
import invoiceTotal from './invoice-total';

export default [invoiceDate, invoiceNumber, invoiceSubtotal, invoiceTotal, invoiceDownload];
